import React from 'react';
import cn from 'classnames';
import type { IconProps } from '../icon-prop-types';
import { IconSizes } from '../icon-prop-types';
import * as Styles from '../Icon.module.scss';

export const MiddleSchoolIcon = ({ fill = 'black', size = 'xsmall' }: IconProps) => {
    const fillStyles = cn(Styles[fill], Styles.fill);
    const iconSize = IconSizes[size];
    return (
        <svg
            width={iconSize}
            height={iconSize}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <path
                className={fillStyles}
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.2974 2.28844L5.29737 8.2131C5.1071 8.40099 5 8.65725 5 8.92466V20H3C2.44772 20 2 20.4477 2 21C2 21.5523 2.44772 22 3 22H6H10H14H18H21C21.5523 22 22 21.5523 22 21C22 20.4477 21.5523 20 21 20H19V8.92466C19 8.65725 18.8929 8.40099 18.7026 8.2131L12.7026 2.28844C12.3131 1.90385 11.6869 1.90385 11.2974 2.28844ZM13 15V20H11V15H13ZM15 14V20H17V9.343L12 4.405L7 9.342V20H9V14C9 13.4477 9.44772 13 10 13H14C14.5523 13 15 13.4477 15 14ZM15 10.5C15 9.94772 14.5523 9.5 14 9.5H10C9.44772 9.5 9 9.94772 9 10.5C9 11.0523 9.44772 11.5 10 11.5H14C14.5523 11.5 15 11.0523 15 10.5Z"
            />
            <mask
                id="mask0_5615_8769"
                style={{ maskType: 'luminance' }}
                maskUnits="userSpaceOnUse"
                x="2"
                y="2"
                width="20"
                height="20"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.2974 2.28844L5.29737 8.2131C5.1071 8.40099 5 8.65725 5 8.92466V20H3C2.44772 20 2 20.4477 2 21C2 21.5523 2.44772 22 3 22H6H10H14H18H21C21.5523 22 22 21.5523 22 21C22 20.4477 21.5523 20 21 20H19V8.92466C19 8.65725 18.8929 8.40099 18.7026 8.2131L12.7026 2.28844C12.3131 1.90385 11.6869 1.90385 11.2974 2.28844ZM13 15V20H11V15H13ZM15 14V20H17V9.343L12 4.405L7 9.342V20H9V14C9 13.4477 9.44772 13 10 13H14C14.5523 13 15 13.4477 15 14ZM15 10.5C15 9.94772 14.5523 9.5 14 9.5H10C9.44772 9.5 9 9.94772 9 10.5C9 11.0523 9.44772 11.5 10 11.5H14C14.5523 11.5 15 11.0523 15 10.5Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0_5615_8769)">
                <rect width="24" height="24" className={fillStyles} />
            </g>
        </svg>
    );
};
